import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=20e354f4&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=js"
export * from "./transfer.vue?vue&type=script&lang=js"
import style0 from "./transfer.vue?vue&type=style&index=0&id=20e354f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e354f4",
  null
  
)

export default component.exports